<template>
  <v-file-input
    class='mt-6'
    :disabled='!input.isEdit'
    @change='file'
    :label="item.Attachment ? item.Attachment.Name : 'добавит файл' "
    outlined
    dense
  />
</template>

<script>
import { fileService } from '~/services/FileNextNumberService'
import {coreApi} from '~/services/core'

export default {
  props: {
    contract: Object,
    item: Object,
    input: Object
  },
  methods: {
    async file(file) {
      if (file){
        const data = this.contract
        const fileId = await fileService.generateId()
        const res = await fileService.upload(fileId.data.Id, file)
        this.item.Attachment = res.data

        await coreApi.put('/contract', data)

      }

    },
  }
}
</script>

